import { toRaw } from 'vue';
import { createStore } from 'vuex';

const STORAGE_KEY = 'slideAppData';

export default createStore({
  state: {
    slides: ["おはようございます！", "予定: 会議10:00", "昼食はカレー🍛", "午後は資料作成"],
    interval: 3000,
    submissions: [], // 提出物のリスト id(1-3), name
    students: [], // 生徒のリスト id(7), name
    submissionStatus: {} // 提出状況
  },
  mutations: {
    updateSlides(state, slides) {
      state.slides = slides;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },
    updateInterval(state, interval) {
      state.interval = interval;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },
    saveSubmissions(state, submissions) { // 提出物保存
      state.submissions = submissions;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },
    saveStudents(state, students) { // 生徒保存
      state.students = students;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },
    saveStatus(state, submissionStatus) { // 提出状況保存
      // console.log('index:save');
      // console.log(toRaw(submissionStatus));
      state.submissionStatus = toRaw(submissionStatus);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    },
    loadFromStorage(state) {
      const data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        const parsed = JSON.parse(data);
        state.slides = parsed.slides;
        state.interval = parsed.interval;
        state.submissions = parsed.submissions;
        state.students = parsed.students;
        state.submissionStatus = parsed.submissionStatus;
      }
    }
  },
  getters: {
    slides: (state) => state.slides,
    interval: (state) => state.interval,
    submissions: (state) => state.submissions,
    students: (state) => state.students,
    submissionStatus: (state) => state.submissionStatus
  },
  actions: {
    init({ commit }) {
      commit('loadFromStorage');
    }
  }
});
